import React, { useState, useEffect } from 'react';
// Error 'ShieldLock' tidak ada, diganti dengan 'Lock' yang valid
import { Plus, Trash2, Save, RefreshCw, Loader2, GripVertical, AlertTriangle, CheckCircle, Lock, Unlock } from 'lucide-react';

// --- KONFIGURASI ---
// Ganti dengan URL API Worker yang Anda deploy
const API_URL = 'https://api-dashboard-menu.toto855master.workers.dev/'; 
// Ganti dengan Kunci Rahasia yang Anda buat
const API_KEY = 'my-super-secret-key-12345!';
// PIN untuk mengakses dashboard
const CORRECT_PIN = "225789";
// ---------------------

/**
 * Komponen Login PIN
 */
const PinLogin = ({ onPinSubmit, error }) => {
  const [pinInput, setPinInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onPinSubmit(pinInput);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 font-sans text-gray-100 p-4">
      {/* Penyesuaian padding untuk seluler */}
      <div className="w-full max-w-sm p-6 sm:p-8 bg-gray-800 rounded-2xl shadow-2xl border border-gray-700 animate-fade-in-up">
        {/* Ikon 'ShieldLock' diganti dengan 'Lock', ukuran disesuaikan */}
        <Lock className="w-12 h-12 sm:w-16 sm:h-16 text-blue-400 mx-auto mb-6" />
        {/* Ukuran font disesuaikan untuk seluler */}
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-100 mb-4">Akses Terbatas</h2>
        <p className="text-gray-400 text-center mb-8">Masukkan PIN Anda untuk melanjutkan.</p>
        
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={pinInput}
            onChange={(e) => setPinInput(e.target.value)}
            // Ukuran font input disesuaikan
            className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg shadow-sm text-gray-100 text-center text-xl sm:text-2xl tracking-widest placeholder-gray-500 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            placeholder="******"
            autoFocus
          />
          {error && (
            <p className="text-red-400 text-center mt-4 text-sm animate-shake">{error}</p>
          )}
          <button
            type="submit"
            // Ukuran font tombol disesuaikan
            className="w-full flex items-center justify-center mt-8 px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition duration-300 ease-in-out transform hover:scale-105 font-semibold text-base sm:text-lg"
          >
            <Unlock className="w-5 h-5 mr-2" />
            Buka
          </button>
        </form>
      </div>
    </div>
  );
};


/**
 * Komponen utama Aplikasi Dashboard
 */
export default function App() {
  // State Autentikasi
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authError, setAuthError] = useState(null);

  // State untuk menyimpan konfigurasi menu (Array dari Array tombol)
  const [menuConfig, setMenuConfig] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // State baru untuk modal konfirmasi hapus
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null); // Menyimpan index baris yang akan dihapus

  // Efek untuk memuat data saat komponen pertama kali dimuat
  useEffect(() => {
    // Hanya muat data jika sudah terautentikasi
    if (isAuthenticated) {
      loadMenuData();
    }
  }, [isAuthenticated]); // <-- Tambahkan isAuthenticated sebagai dependensi

  /**
   * Cek PIN yang dimasukkan
   */
  const handlePinSubmit = (pinInput) => {
    if (pinInput === CORRECT_PIN) {
      setIsAuthenticated(true);
      setAuthError(null);
    } else {
      setAuthError("PIN salah. Coba lagi.");
      // Tampilkan error selama 3 detik
      setTimeout(() => setAuthError(null), 3000);
    }
  };

  /**
   * (NYATA) Memuat data dari backend/API Worker
   */
  const loadMenuData = async () => {
    // ... (fungsi loadMenuData tetap sama) ...
    setIsLoading(true);
    setError(null);
    setSuccess(null);
    
    try {
      const response = await fetch(API_URL, {
        headers: {
          'Authorization': `Bearer ${API_KEY}`
        }
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      setMenuConfig(data || []); // Pastikan data adalah array
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setError(`Gagal memuat data menu. (${err.message})`);
      setIsLoading(false);
    }
  };

  /**
   * (NYATA) Menyimpan data ke backend/API Worker
   */
  const handleSaveMenu = async () => {
    // ... (fungsi handleSaveMenu tetap sama) ...
    setIsSaving(true);
    setError(null);
    setSuccess(null);
    
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`
        },
        body: JSON.stringify(menuConfig) // Kirim array menu
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.error || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      if (result.success) {
        setSuccess("Menu berhasil disimpan!");
      }
      setIsSaving(false);
      // Hapus pesan sukses setelah 3 detik
      setTimeout(() => setSuccess(null), 3000);

    } catch (err) {
      console.error(err);
      setError(`Gagal menyimpan data menu. (${err.message})`);
      setIsSaving(false);
    }
  };

  // --- Fungsi Handler untuk Mengubah State ---

  /** Menambah baris baru (array kosong) ke menu */
  const handleAddNewRow = () => {
    // ... (fungsi handleAddNewRow tetap sama) ...
    setMenuConfig([...menuConfig, []]);
  };

  /** Membuka modal konfirmasi penghapusan baris */
  const promptDeleteRow = (rowIndex) => {
    setRowToDelete(rowIndex);
    setShowDeleteModal(true);
  };

  /** Membatalkan penghapusan dan menutup modal */
  const cancelDeleteRow = () => {
    setShowDeleteModal(false);
    setRowToDelete(null);
  };
  
  /** Mengkonfirmasi penghapusan baris */
  const confirmDeleteRow = () => {
    if (rowToDelete !== null) {
      setMenuConfig(menuConfig.filter((_, i) => i !== rowToDelete));
    }
    setShowDeleteModal(false);
    setRowToDelete(null);
  };


  /** Menambah tombol baru ke baris tertentu */
  const handleAddButtonToRow = (rowIndex) => {
    // ... (fungsi handleAddButtonToRow tetap sama) ...
    const newConfig = [...menuConfig];
    newConfig[rowIndex].push({ text: 'Tombol Baru', url: 'https://' });
    setMenuConfig(newConfig);
  };

  /** Menghapus tombol dari baris tertentu */
  const handleDeleteButton = (rowIndex, buttonIndex) => {
    // ... (fungsi handleDeleteButton tetap sama) ...
    const newConfig = [...menuConfig];
    newConfig[rowIndex] = newConfig[rowIndex].filter((_, i) => i !== buttonIndex);
    setMenuConfig(newConfig);
  };

  /** Mengubah data (teks/url) dari tombol tertentu */
  const handleButtonChange = (rowIndex, buttonIndex, field, value) => {
    // ... (fungsi handleButtonChange tetap sama) ...
    const newConfig = [...menuConfig];
    newConfig[rowIndex][buttonIndex][field] = value;
    setMenuConfig(newConfig);
  };

  // --- Render Komponen ---

  // Tampilkan layar login jika belum terautentikasi
  if (!isAuthenticated) {
    return <PinLogin onPinSubmit={handlePinSubmit} error={authError} />;
  }

  // Tampilkan dashboard jika sudah terautentikasi
  // Padding utama disesuaikan untuk seluler
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 font-sans text-gray-100 p-2 sm:p-4 md:p-8">
      <div className="max-w-5xl mx-auto">
        
        {/* Header: Dibuat tumpuk di seluler (flex-col) */}
        <header className="mb-6 sm:mb-8 flex flex-col sm:flex-row justify-between items-center bg-gray-800 p-4 sm:p-6 rounded-xl shadow-2xl border border-gray-700">
          <div>
            {/* Ukuran font header disesuaikan */}
            <h1 className="text-2xl sm:text-4xl font-extrabold text-blue-400 text-center sm:text-left">Editor Menu BOT</h1>
            <p className="text-gray-400 mt-2 text-base sm:text-lg text-center sm:text-left">Kelola tombol interaktif bot Telegram Anda.</p>
          </div>
          {/* Tombol diberi margin atas di seluler */}
          <div className="flex space-x-3 mt-4 sm:mt-0">
            <button
              onClick={loadMenuData}
              disabled={isLoading}
              className="flex items-center justify-center px-4 sm:px-5 py-2 sm:py-2.5 bg-gray-700 text-blue-300 rounded-lg shadow-md hover:bg-gray-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105"
            >
              {isLoading ? <Loader2 className="animate-spin w-5 h-5" /> : <RefreshCw className="w-5 h-5" />}
              {/* Teks tombol disembunyikan di layar kecil (sm:inline) */}
              <span className="ml-2 hidden sm:inline font-semibold">Muat Ulang</span>
            </button>
            <button
              onClick={handleSaveMenu}
              disabled={isSaving}
              className="flex items-center justify-center px-4 sm:px-5 py-2 sm:py-2.5 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105"
            >
              {isSaving ? <Loader2 className="animate-spin w-5 h-5" /> : <Save className="w-5 h-5" />}
              {/* Teks tombol disembunyikan di layar kecil (sm:inline) */}
              <span className="ml-2 hidden sm:inline font-semibold">Simpan</span>
            </button>
          </div>
        </header>

        {/* Notifikasi Error */}
        {error && (
          <div className="mb-6 flex items-center p-4 bg-red-800 text-red-200 border border-red-700 rounded-lg shadow-md animate-fade-in-down">
            <AlertTriangle className="w-6 h-6 mr-3 text-red-400" />
            <span className="font-medium">{error}</span>
          </div>
        )}
        
        {/* Notifikasi Sukses */}
        {success && (
          <div className="mb-6 flex items-center p-4 bg-green-800 text-green-200 border border-green-700 rounded-lg shadow-md animate-fade-in-down">
            <CheckCircle className="w-6 h-6 mr-3 text-green-400" />
            <span className="font-medium">{success}</span>
          </div>
        )}

        {/* Konten Editor Menu: Padding disesuaikan */}
        <main className="bg-gray-800 rounded-xl shadow-2xl p-3 sm:p-4 md:p-8 border border-gray-700">
          {isLoading && (
            <div className="flex justify-center items-center h-64">
              <Loader2 className="w-16 h-16 animate-spin text-blue-500" />
            </div>
          )}
          
          {!isLoading && (
            <div className="space-y-6 sm:space-y-8">
              {/* Mapping untuk setiap BARIS */}
              {menuConfig.map((row, rowIndex) => (
                <div key={rowIndex} className="bg-gray-900 border border-gray-700 rounded-xl overflow-hidden shadow-lg animate-fade-in-up">
                  {/* Header Baris: Padding disesuaikan */}
                  <header className="flex justify-between items-center bg-gray-700 p-3 sm:p-4 border-b border-gray-600">
                    <div className="flex items-center">
                      <GripVertical className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500 cursor-grab transition-colors hover:text-blue-400" />
                      {/* Ukuran font header baris disesuaikan */}
                      <h3 className="text-lg sm:text-xl font-bold text-gray-100 ml-2 sm:ml-3">Baris {rowIndex + 1}</h3>
                    </div>
                    <div className="flex space-x-2 sm:space-x-3">
                      <button
                        onClick={() => handleAddButtonToRow(rowIndex)}
                        // Padding tombol disesuaikan
                        className="flex items-center px-3 py-1.5 sm:px-4 sm:py-2 bg-blue-800 text-blue-200 rounded-lg hover:bg-blue-700 transition duration-200 text-sm font-semibold shadow-md"
                      >
                        <Plus className="w-4 h-4 inline-block sm:mr-2" />
                        {/* Teks disembunyikan di layar sangat kecil */}
                        <span className="hidden sm:inline">Tombol</span>
                      </button>
                      <button
                        onClick={() => promptDeleteRow(rowIndex)} // <-- Diubah dari handleDeleteRow
                        // Padding tombol disesuaikan
                        className="flex items-center px-3 py-1.5 sm:px-4 sm:py-2 bg-red-800 text-red-200 rounded-lg hover:bg-red-700 transition duration-200 text-sm font-semibold shadow-md"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </header>

                  {/* Wrapper untuk tombol-tombol di dalam baris: Padding disesuaikan */}
                  <div className="p-3 sm:p-5 space-y-3 sm:space-y-5">
                    {row.length === 0 && (
                      <p className="text-gray-500 text-center italic py-4">Baris ini kosong. Klik "Tombol" di atas untuk menambahkannya.</p>
                    )}
                    
                    {/* Mapping untuk setiap TOMBOL di dalam BARIS */}
                    {row.map((button, buttonIndex) => (
                      // Dibuat tumpuk di seluler (grid-cols-1) dan grid di medium (md:grid-cols-12)
                      <div key={buttonIndex} className="grid grid-cols-1 gap-3 md:grid-cols-12 md:gap-4 items-center p-3 sm:p-4 bg-gray-800 border border-gray-700 rounded-lg shadow-inner animate-fade-in-up">
                        {/* Input Teks Tombol */}
                        <div className="md:col-span-5">
                          <label className="block text-sm font-medium text-gray-300 mb-1">Teks Tombol</label>
                          <input
                            type="text"
                            value={button.text}
                            onChange={(e) => handleButtonChange(rowIndex, buttonIndex, 'text', e.target.value)}
                            placeholder="Contoh: 🌐 Google"
                            className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-100 placeholder-gray-500 transition-colors"
                          />
                        </div>
                        {/* Input URL */}
                        <div className="md:col-span-6">
                          <label className="block text-sm font-medium text-gray-300 mb-1">URL Tujuan</label>
                          <input
                            type="text"
                            value={button.url}
                            onChange={(e) => handleButtonChange(rowIndex, buttonIndex, 'url', e.target.value)}
                            placeholder="Contoh: https://google.com"
                            className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-100 placeholder-gray-500 transition-colors"
                          />
                        </div>
                        {/* Tombol Hapus: Penjajaran disesuaikan untuk seluler */}
                        <div className="md:col-span-1 flex justify-end md:justify-center">
                          <button
                            onClick={() => handleDeleteButton(rowIndex, buttonIndex)}
                            className="text-gray-500 hover:text-red-500 transition-colors p-2 md:p-0"
                            title="Hapus tombol ini"
                          >
                            <Trash2 className="w-5 h-5 sm:w-6 sm:h-6" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {/* Tombol Aksi Bawah: Padding dan font disesuaikan */}
              <button
                onClick={handleAddNewRow}
                className="w-full flex justify-center items-center py-3 px-4 sm:py-4 sm:px-6 border-2 border-dashed border-blue-600 text-blue-400 rounded-xl hover:bg-gray-700 transition duration-300 ease-in-out text-base sm:text-lg font-semibold shadow-md transform hover:scale-105"
              >
                <Plus className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3" />
                Tambah Baris Baru
              </button>
            </div>
          )}
        </main>
        
        {/* Output JSON (untuk debugging): Padding dan font disesuaikan */}
        <footer className="mt-8 sm:mt-10 p-4 sm:p-6 bg-gray-800 rounded-xl shadow-xl border border-gray-700">
          <h4 className="text-xl sm:text-2xl font-bold text-blue-400 mb-3">Struktur JSON Saat Ini</h4>
          <p className="text-gray-400 text-sm mb-4">
            Ini adalah representasi JSON dari menu Anda yang akan disimpan ke Cloudflare KV.
          </p>
          {/* Ukuran font pre disesuaikan */}
          <pre className="bg-gray-950 text-green-400 p-3 sm:p-5 rounded-lg overflow-x-auto text-xs sm:text-sm border border-gray-700 shadow-inner">
            {JSON.stringify(menuConfig, null, 2)}
          </pre>
        </footer>

      </div>

      {/* Modal Konfirmasi Hapus */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75 animate-fade-in-fast">
          <div className="bg-gray-800 rounded-2xl shadow-2xl p-6 sm:p-8 max-w-sm w-full border border-gray-700 animate-fade-in-up-fast">
            <div className="flex items-center justify-center w-16 h-16 mx-auto bg-red-800 rounded-full border-4 border-red-700">
              <AlertTriangle className="w-8 h-8 text-red-300" />
            </div>
            <h3 className="text-2xl font-bold text-center text-gray-100 mt-6 mb-2">Hapus Baris?</h3>
            <p className="text-gray-400 text-center mb-8">
              {/* Pastikan rowToDelete tidak null sebelum mengaksesnya */}
              Anda yakin ingin menghapus <strong>Baris {rowToDelete !== null ? rowToDelete + 1 : ''}</strong>? Tindakan ini tidak dapat diurungkan.
            </p>
            <div className="grid grid-cols-2 gap-4">
              <button
                onClick={cancelDeleteRow}
                className="px-6 py-3 bg-gray-700 text-white rounded-lg shadow-md hover:bg-gray-600 transition duration-300 ease-in-out font-semibold"
              >
                Batal
              </button>
              <button
                onClick={confirmDeleteRow}
                className="px-6 py-3 bg-red-600 text-white rounded-lg shadow-md hover:bg-red-700 transition duration-300 ease-in-out font-semibold"
              >
                Ya, Hapus
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

